module.exports = __webpack_public_path__ + "media/images/nytimes-237f2ce524ccb6455c52f775f5f64a292cc703d3985c889358a24034b6982c06.jpg";